(function () {
  'use strict';

  angular.module('ringbaPortal').component('whitelabelComponentEditorForm', {
    bindings: {
      componentName: '<',
      isLightTheme: '<',
      onColorUpdate: '<',
      onTextValueChange: '<',
      modifiedWhitelabelTheme: '<' // This is used in previewing a page's changes
    },
    controller: WhitelabelComponentEditorFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/whitelabel-editor/whitelabel-component-editor-form/whitelabel-component-editor-form.view.html'
  });

  function WhitelabelComponentEditorFormController(
    $state,
    $window,
    cacheService,
    whitelabelEditorService
  ) {
    'ngInject';

    const vm = this;

    vm.colorPickerOptions = {
      format: 'hex',
      required: true,
      placeholder: 'Choose color',
      inputClass: 'form-control',
      pos: 'bottom right',
      reset: {
        show: true
      },
      restrictToFormat: true,
      preserveInputFormat: true,
      alpha: true,
      hue: true,
      saturation: true,
      lightness: true // Note: In the square mode this is HSV and in round mode this is HSL
    };

    vm.colorPickerEventApi = {
      onChange: onColorChange,
      onReset: onColorChange
    };

    vm.propertiesValues = {};

    vm.$onInit = onInit;
    vm.onColorChange = onColorChange;
    vm.onTextChange = onTextChange;
    vm.handlePreviewPage = handlePreviewPage;

    function onInit() {
      vm.componentProperties = _getComponentPropertiesFromService(vm.componentName);
      _getCurrentCSSVariableValue(vm.componentProperties);
      vm.componentPreview = whitelabelEditorService.getComponentPreviewState(vm.componentName);
    }

    function onColorChange(api, color) {
      const property = api.getScope().$parent.property;
      color = color.replace(/[#]/g, '');
      vm.onColorUpdate(property.variablesToChange, color, vm.componentName, property.name);
    }

    function onTextChange(textValue, property) {
      vm.onTextValueChange(textValue, property.variablesToChange);
    }

    function handlePreviewPage(state, params) {
      const whitelabelTheme = angular.copy(vm.modifiedWhitelabelTheme);
      whitelabelTheme.isLightTheme = vm.isLightTheme;
      cacheService.set(state + '-preview', whitelabelTheme, {
        persistence: true
      });
      const url = $state.href(state, _.merge(params, { preview: 'true' }));
      $window.open(url, 'preview-window-' + state).location.reload();
    }

    function _getComponentPropertiesFromService(componentName) {
      try {
        return angular.copy(whitelabelEditorService.getComponentPropertiesList()[componentName].properties);
      } catch {
        return [];
      }
    }

    function _getCurrentCSSVariableValue(properties) {
      _.forEach(properties, function(property) {
        const currentValue = whitelabelEditorService.getCSSVariableValue(property.variablesToChange[0], vm.isLightTheme);
        let value;
        if (!property.isTextInput) {
          value = (currentValue && currentValue.trim().toUpperCase()) || '';
        } else {
          value = (currentValue && currentValue.trim()) || '';
          value = value.replace(/"/g, '');
        }

        vm.propertiesValues[property.name] = value.replace('#', '');
      });
    }

  }
})();
